/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';

import { initialState } from 'modules/common/auth/slice';
import { capitalizeFirst } from 'modules/common/helpers/strings';

const selectDomain = (state) => state['feature/base-auth'] || initialState;
//
export const selectAuthUser = createSelector([selectDomain], (authState) => authState.user);
//
export const selectTokens = createSelector([selectDomain], (authState) => authState.tokens);
//
export const selectRefreshToken = createSelector(
  [selectDomain],
  (authState) => authState.tokens?.refreshToken
);
//
export const selectAccessToken = createSelector(
  [selectDomain],
  (authState) => authState.tokens?.accessToken
);
//
export const selectResetPasswordToken = createSelector(
  [selectDomain],
  (authState) => authState?.resetPasswordToken
);
//
export const selectUserFullName = createSelector(
  [selectDomain],
  (authState) =>
    `${capitalizeFirst(authState?.user?.firstName)} ${capitalizeFirst(authState?.user?.lastName)}`
);
//
export const selectOrganizationId = createSelector(
  [selectDomain],
  (authState) => authState?.user?.organizationId
);
//
export const selectAccessTokenExpired = createSelector(
  [selectDomain],
  (authState) => authState.tokens?.expiresIn
);
/**
 * Obtain id token from auth slice
 */
export const selectIdToken = createSelector(
  [selectDomain],
  (authState) => authState.tokens?.idToken
);
/**
 * Getting is token revoked state for dashboard component
 */
export const selectTokenRevocation = createSelector(
  [selectDomain],
  (state) => state.isTokenRevoked
);
/**
 * Getting select organization state to components
 */
export const selectOrganization = createSelector(
  [selectDomain],
  (authState) => authState?.organization
);
//
export const selectAuthLoading = createSelector([selectDomain], (authState) => authState?.loading);
